export default __webpack_public_path__ + "static/media/audio.c213ed81.mpeg";